<template>
    <div class="staticpage" :style="$root.bodyfit_style_start">

        <div class="staticpage_area">

            <div class="staticpage_back_area display_responsive">
                <div class="back_btn_div" @click="$router.go(-1)">
                    <div class="back_btn"></div>
                </div>
            </div>

            <div class="static_page_title">{{page_title}}</div>

            <div class="staticpage_div">
                <div class="staticpage_inner_area">
                    <div class="staticpage_content" v-html="content"></div>
                </div>
            </div>

        </div>

    </div>
</template>
 
<script>
export default {
  data() {
    return {
        type:"",
        code: "",
        content: "",
        page_title:""
    };
  },
  computed: {
    info() {
      return this.$root.info;
    },
    label() {
      return this.$root.getLabel();
    },
    cart() {
      return this.$root.cart;
    },
  },
  components: {},
  created() {

    var app = this;
    app.LoadContent(app.$route.params.type,app.$route.params.code);       

  },
  watch: {
      '$route.params.type': function (type) {
          this.LoadContent(type, this.$route.params.code);
      },
      '$route.params.code': function (code) {
          this.LoadContent(this.$route.params.type, code);
      },
      '$root.info.lang': function (lang) {
          this.LoadContent(this.$route.params.type, this.$route.params.code);
      },
  },
  destroyed() {
  },
  methods: {
    getItemSubfix() {
      return this.$root.getItemSubfix();
    },
    LoadContent(type,code) {
        var app = this;
        app.code = code;
        app.content = "";
        app.$root.getCurrentPathName();

        if (type == "s") {

            app.page_title = app.label["static_page_title_" + code] || "";
            $.ajax({
                type: "GET",
                url: "/files/static_page/" + app.info.lang + "/" + code + ".htm",
                dataType: "html",
                success: (data) => {
                    app.content = data;
                }
            }).catch(function () {
            });

        } else if (type == "sl") {

            app.page_title = app.label["static_stand_alone_page_title_" + code] || "";
            $.ajax({
                type: "GET",
                url: "/files/stand_alone_page/" + app.info.lang + "/" + code + ".htm",
                dataType: "html",
                success: (data) => {
                    app.content = data;
                }
            }).catch(function () {
            });

        } else if (type == "sc") {

            var ShopCategoryStatisPage = app.info.ShopCategoryStatisPage.filter((o) => o.page_code == code);
            if (ShopCategoryStatisPage.length > 0) {
                $.ajax({
                    type: "GET",
                    url: "/files/shop_category_static_page/" + app.info.selectShop.shopCode + "/" + app.info.lang + "/" + code + ".htm",
                    dataType: "html",
                    success: (data) => {
                        app.content = data;
                    }
                }).catch(function () {
                });
            }

        }
        else {
        }

    }

  },
};
</script>
